import { AxiosResponse } from 'axios';
import { ON_FARM_STORAGE_RATES_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet } from './httpCommon/appAxios.service';
import { OnFarmStorageRatesResponse } from '../types/interfaces/onFarmStorageRates.interfaces';

export const getOnFarmStorageRates = (): Promise<AxiosResponse<OnFarmStorageRatesResponse>> => {
  return appContextGet(ON_FARM_STORAGE_RATES_API_ENDPOINTS.GET);
};
